import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    email: Yup.string()
        .required('Введите почту')
        .email('Неверный формат почты'),
});

export default validationSchema;
